import AutoReconcileModal from '@app/application/reconciliation/sections/auto-reconciliation/components/auto-reconcile-modal'
import AccountEntriesModal from '@app/application/reconciliation/sections/account-entries-modal/account-entries-modal.vue'
import AdjustmentsModal from '@app/application/adjustments/components/adjustments-modal.vue'
import autoReconcileCreateStoreFromData from '@app/application/reconciliation/sections/auto-reconciliation/utils/create-store-from-data'
import autoReconcileCreateStore from '@app/application/reconciliation/sections/auto-reconciliation/store'
import AccountsLockingModal from '@app/application/accounts/accounts-locking-modal.vue'
import InputAutomationSteps from '@app/application/ai_ocr_requests/components/input-automation-steps.vue'
import MarkProposalAsFinalizedModal from '@app/application/reconciliation/components/mark-proposal-as-finalized-modal'
import ShareWorkflowWithPulseUsersModal from '@app/application/pulse-share/share-workflow-with-pulse-users-modal'
import ConfirmDeleteSegmentModal from '@app/insights/components/segments/confirm-delete-segment-modal'
import FileFollowersModal from '@app/application/workflows/components/file-followers-modal.vue'
import ManageCompanyLinksModal from '@app/application/company_links/components/manage-company-links-modal'
import ExternalCompanySelectorModal from '@app/application/company_links/components/external-company-selector-modal'
import DeleteCompanyLinkModal from '@app/application/company_links/components/delete-company-link-modal'
import AddConfirmationModal from '@app/application/marketplace/add-confirmation-modal.vue'
import ConfirmCheckToggleApplicableModal from '@app/application/communication/sections/communication/components/checks/confirm-check-toggle-applicable-modal.vue'
import ConfirmReassignCheckModal from '@app/application/communication/sections/communication/components/checks/confirm-reassign-check-modal.vue'
import FirmTemplatesConfirmationModal from '@app/application/marketplace/firm-templates-confirmation-modal.vue'
import PublishCheckListConfirmationModal from '@app/application/check_lists/publish-check-list-confirmation-modal.vue'
import ResetCheckListConfirmationModal from '@app/application/check_lists/reset-check-list-confirmation-modal.vue'
import CopyCheckListModal from '@app/application/check_lists/copy-check-list-modal.vue'
import AccountDetailsModal from '@app/application/report/components/account-details-modal.vue'
import ReportElementDetailsModal from '@app/application/report/components/report-element-details-modal.vue'
import EchartsGraphModal from '@app/application/report/screens/graphs-echarts/components/echarts-graph-modal.vue'

export default [
  [
    'account-entries-modal',
    {
      component: AccountEntriesModal,
      meta: { singletonId: 'account-entries-modal' },
    },
  ],
  [
    'accounts-locking-modal',
    {
      component: AccountsLockingModal,
      meta: { singletonId: 'accounts-locking-modal' },
    },
  ],
  [
    'adjustments-modal',
    {
      component: AdjustmentsModal,
      meta: { singletonId: 'adjustments-modal' },
    },
  ],
  [
    'auto-reconcile-modal',
    {
      component: AutoReconcileModal,
      createStore: autoReconcileCreateStoreFromData(autoReconcileCreateStore),
      meta: { singletonId: 'auto-reconcile-modal' },
    },
  ],
  [
    'file-followers-modal',
    {
      component: FileFollowersModal,
      meta: { singletonId: 'file-followers-modal' },
    },
  ],
  [
    'mark-proposal-as-finalized-modal',
    {
      component: MarkProposalAsFinalizedModal,
      meta: { singletonId: 'mark-proposal-as-finalized-modal' },
    },
  ],
  [
    'input-automation-steps-modal',
    {
      component: InputAutomationSteps,
      meta: { singletonId: 'input-automation-steps' },
    },
  ],
  [
    'share-workflow-with-pulse-users-modal',
    {
      component: ShareWorkflowWithPulseUsersModal,
      meta: { singletonId: 'share-workflow-with-pulse-users-modal' },
    },
  ],
  [
    'confirm-delete-segment-modal',
    {
      component: ConfirmDeleteSegmentModal,
      meta: { singletonId: 'confirm-delete-segment-modal' },
    },
  ],
  [
    'external-company-selector-modal',
    {
      component: ExternalCompanySelectorModal,
      meta: { singletonId: 'external-company-selector-modal' },
    },
  ],
  [
    'manage-company-links-modal',
    {
      component: ManageCompanyLinksModal,
      meta: { singletonId: 'manage-company-links-modal' },
    },
  ],
  [
    'delete-company-link-modal',
    {
      component: DeleteCompanyLinkModal,
      meta: { singletonId: 'delete-company-link-modal' },
    },
  ],
  [
    'add-confirmation-modal',
    {
      component: AddConfirmationModal,
      meta: { singletonId: 'add-confirmation-modal' },
    },
  ],
  [
    'confirm-check-toggle-applicable-modal',
    {
      component: ConfirmCheckToggleApplicableModal,
      meta: { singletonId: 'confirm-check-toggle-applicable-modal' },
    },
  ],
  [
    'confirm-reassign-check-modal',
    {
      component: ConfirmReassignCheckModal,
      meta: { singletonId: 'confirm-reassign-check-modal' },
    },
  ],
  [
    'firm-templates-confirmation-modal',
    {
      component: FirmTemplatesConfirmationModal,
      meta: { singletonId: 'firm-templates-confirmation-modal' },
    },
  ],
  [
    'publish-check-list-confirmation-modal',
    {
      component: PublishCheckListConfirmationModal,
      meta: { singletonId: 'publish-check-list-confirmation-modal' },
    },
  ],
  [
    'reset-check-list-confirmation-modal',
    {
      component: ResetCheckListConfirmationModal,
      meta: { singletonId: 'reset-check-list-confirmation-modal' },
    },
  ],
  [
    'copy-check-list-modal',
    {
      component: CopyCheckListModal,
      meta: { singletonId: 'copy-check-list-modal' },
    },
  ],
  [
    'report-account-details-modal',
    {
      component: AccountDetailsModal,
      meta: { singletonId: 'report-account-details-modal' },
    },
  ],
  [
    'report-element-details-modal',
    {
      component: ReportElementDetailsModal,
      meta: { singletonId: 'report-element-details-modal' },
    },
  ],
  [
    'echarts-graph-modal',
    {
      component: EchartsGraphModal,
      meta: { singletonId: 'echarts-graph-modal' },
    },
  ],
]
